import { Link, Text } from "basis";
import { useEventTracking } from "react-event-tracker";
import { SvgInline } from "../SvgInline/SvgInline";
import styles from "./homepage.module.scss";
import { LoginWidget } from "./LoginWidget/LoginWidget";

export const LoginSection = () => {
  const { trackEvent } = useEventTracking();
  return (
    <div className={`${styles.container} ${styles.loginSection}`}>
      <div className={styles.registerSection}>
        <h1 className="h2">
          Finance. <strong>Evolved.</strong>
          <br />
          Latitude Service Centre <span className={styles.betaIcon}>Beta</span>
        </h1>
        <Text margin="0 0 4 0">
          First time visiting the new Latitude Service Center?
          <br />
          You'll need to create yourself a Latitude ID and Password, unless you
          already use the Latitude mobile app and then you can use the same
          Latitude ID and Password.
        </Text>
        <Link
          appearance="secondary-button"
          variant="blue-button"
          href="/register"
          newTab={false}
          onClick={() =>
            trackEvent({
              event: {
                category: "cta",
                action: "registration-link",
                location: "Finance. Evolved.",
                label: "Register",
              },
            })
          }
        >
          Register
        </Link>
      </div>
      <div className={styles.loginWidget}>
        <SvgInline className={styles.confettiLeft} name="confetti" />
        <SvgInline className={styles.confettiRight} name="confetti" />
        <LoginWidget className={styles.loginWrapper} />
      </div>
    </div>
  );
};
